import React from 'react';
import { IconProps } from './icons.models';

const SsnKeyIcon: React.FC<IconProps> = ({
    width = 16,
    height = 16,
    fillColor = '#3B78CE',
    className,
    onClick,
}) => {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            onClick={onClick}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M10.3334 5.0013L11.8667 6.53464C11.9913 6.65679 12.1589 6.72521 12.3334 6.72521C12.5079 6.72521 12.6754 6.65679 12.8 6.53464L14.2 5.13464C14.3222 5.01002 14.3906 4.84247 14.3906 4.66797C14.3906 4.49347 14.3222 4.32592 14.2 4.2013L12.6667 2.66797" stroke={fillColor || '#FFC107'} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14 1.33203L7.59998 7.73203" stroke={fillColor || '#FFC107'} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.00004 14.0013C7.02508 14.0013 8.66671 12.3597 8.66671 10.3346C8.66671 8.30959 7.02508 6.66797 5.00004 6.66797C2.975 6.66797 1.33337 8.30959 1.33337 10.3346C1.33337 12.3597 2.975 14.0013 5.00004 14.0013Z" stroke={fillColor || '#FFC107'} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default SsnKeyIcon;
